module.exports = __webpack_public_path__ + "img/view_device_c1_one.460d7208.jpg";